export default {
  GET_REPORT_WORKERS_TABLE_RESULTS: state => state.report_workers_table.results,
}
